import { Box, Typography } from "@mui/material";
import ProfileAvatar from "../ProfileAvatar";
import StatusComponent from "../../../stories/StatusComponent/StatusComponent";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Genaricfunctions from "../../../utils/Genaricfunctions";

const HistoryItem = (props) => {
  const navigate = useNavigate();
  let timeago = "";
  if (props.createdDate) {
    timeago = moment(props.createdDate).fromNow();
  }
  const handlePQRenewation = (vendorId) => {
    navigate("/ListOfPotentialClients?Vendor=" + vendorId + "&TypeIdx=2");
  };
  const handleClick = (pqId, sectionId) => {
    window.location="/vendordetails?pqid=" +
      pqId +
      "&tab=Questionnaire&sectionid=" +
      sectionId;
    // navigate(
    //   "/vendordetails?pqid=" +
    //   pqId +
    //   "&tab=Questionnaire&sectionid=" +
    //   sectionId
    // );
  };

  return (
    <>
      <Box className="d-flex align-items-start gap-3 w-100 flex-nowrap">
        <ProfileAvatar showUserIcon={false} senderName={props.createdBy} />
        <Box className="w-100">
          <Box className="d-flex gap-2 w-100">
            <Typography
              variant="body1"
              className="text-truncate fw-semibold"
              sx={{ color: "black", maxWidth: "calc(100% - 130px)" }}
            >
              {props.createdBy}
            </Typography>
            <Typography className="text-muted">
              {/* {timeago} */}
              {Genaricfunctions("", props.createdDate)}
            </Typography>
          </Box>
          {props.notificationType === 3 ? (
            <>
              <Typography className="text-muted mb-2">
                <span style={{ fontWeight: "bold" }}>{props.comment} </span> - Changed status to
              </Typography>
              <StatusComponent type={props.type} RemoveDescription={true} />
            </>
          ) : props.notificationType === 2 ? (
            <>
              <Typography className="text-muted mb-2">
                Changed status to
              </Typography>
              <StatusComponent type={props.type} RemoveDescription={true} />
            </>
          ) : props.notificationType === 1 ? (
            <>
              {props.isPQRenewable === true ? (
                <Typography className="text-muted mb-2">
                  {props.comment}{" "}
                  <span
                    className="text-primary cursor-pointer"
                    onClick={() => handlePQRenewation(props.vendorId)}
                  >
                    Want to Renew?
                  </span>
                </Typography>
              ) : (
                <Typography className="text-muted mb-2">
                  {props.comment}
                </Typography>
              )}
            </>
          ) : props.notificationType === 4 &&
            props.isDocumentSpecific === true &&
            props.sectionId !== undefined ? (
            <>
              <Typography className="text-muted mb-2">
                {props.comment}{" "}
                <span
                  className="text-primary cursor-pointer"
                  onClick={() =>
                    handleClick(props.prequalificationId, props.sectionId)
                  }
                >
                  {" View Document"}
                </span>
              </Typography>
            </>
          ) : (
            <>
              <Typography className="text-muted mb-2">
                {props.comment}
              </Typography>
            </>
          )}
        </Box>
      </Box>

      <hr />
    </>
  );
};
export default HistoryItem;
